import { Component, OnInit } from '@angular/core';
import { User } from '../../shared/user/user.model';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { Globals } from '../../global';
import { ClientService } from '../../services/client.service';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
	public user: User;
	public clients: any = [];
	public data: any;
	public event: any;
	public userId: string = '';
	public isRequired: boolean = true;
	public selectedClient: any = '';
	public clientsNames: any = [];
	private path: string = '';
	public userToDelete: string;
	public role: string;

	public rowsOnPage: number = 10;
	public filterQuery: string = "";
	public sortBy: string = "";
	public sortOrder: string = "desc";

	roles:any;
	
	checkboxes = [
		{
			"id": "lowercase",
			"label": "a-z",
			"library": "abcdefghijklmnopqrstuvwxyz"
		}, {
			"id": "uppercase",
			"label": "A-Z",
			"library": "ABCDEFGHIJKLMNOPWRSTUVWXYZ"
		}, {
			"id": "numbers",
			"label": "0-9",
			"library": "0123456789"
		}, {
			"id": "symbols",
			"label": "!-?",
			"library": "!@#$%^&*-_=+\\|:;',.\<>/?~"
		}
	]

	dictionary: Array<String>;

	passwordLenght: number = 8;
	buttonLabel: string = "Generar contraseña";
	newPassword: string;
	show: boolean;

	constructor(public userService: UserService, public authService: AuthService, private clientService: ClientService, private route: ActivatedRoute, private globals: Globals) {
		this.show = false;
		this.user = new User();
		this.path = this.route.snapshot.data['name'];
		this.role = JSON.parse(localStorage.getItem('user')).data.role;
		this.roles = this.globals.roles;
	}

	save() {
		let body = {
			firstName: this.user.firstName,
			lastName: this.user.lastName,
			role: this.user.role,
			phone: this.user.phone,
			email: this.user.email,
			client: this.user.client,
			customAssignmentId: this.user.customAssignmentId
		}

		/*if(this.user.role === "sales"){
			body['assignamentId'] = this.customUserId;
		}*/
		
		if (this.userId !== "") {
			this.userService.update(body)
				.subscribe((data:any) => {
					if (data.success === true) {
						this.getAll();
						document.querySelector("#"+this.event).classList.remove('md-show');
					} else {}
				})
		} else {
			body['password'] = this.user.password;
			this.userService.create(body)
				.subscribe((data:any) => {
					if (data.success === true) {
						this.getAll();
						document.querySelector("#"+this.event).classList.remove('md-show');
					} else {}
				})
		}
	}

	create() {
		const body = {
			firstName: this.user.firstName,
			lastName: this.user.lastName,
			email: this.user.email,
			phone: this.user.phone,
			password: this.user.password,
			role: this.user.role
		}
		
		this.userService.create(body)
			.subscribe((data:any) => {
				if (data.success === true) {
					this.getAll();
				} else {}
			})
	}

	// Generate password
	generatePassword() {

		// Create array from chosen checkboxes
		this.dictionary = [].concat(
			this.checkboxes[0].library.split(""),
			this.checkboxes[1].library.split(""),
			this.checkboxes[2].library.split(""),
			this.checkboxes[3].library.split("")
		);

		// Generate random password from array
		var newPassword = "";
		for (var i = 0; i < this.passwordLenght; i++) {
			newPassword += this.dictionary[Math.floor(Math.random() * this.dictionary.length)];
		}
		this.newPassword = newPassword;
		this.user.password = this.newPassword;
	}

	showPassword() {
		this.show = this.show ? false : true;
	}

	getAll() {
		this.userService.getAll()
			.subscribe((response:any)=> {
				// Add "name" property to all elements to work with "data-filter" on search.
				this.data = response.data.map(user => ({...user, name: user.firstName + " " + user.lastName}));
			}, (err:any) => {
				if (err.status === 401) {
					this.authService.logout();
				}
			});
	}

	getByClientAndRole() {
		let body = {
			client: JSON.parse(localStorage.getItem('user')).data.client[0],
			role: JSON.parse(localStorage.getItem('user')).data.role
		}
		this.userService.getByClientAndRole(body)
			.subscribe((response:any) => {
				this.data = response.data;
			});
	}

	getUser(id) {
		this.data.forEach(element => {
			if (element._id == id) {
				this.user =  element;
				this.user.password = "";
			}
		});
	}

	getClients() {
		this.clientService.getAll()
			.subscribe((response: any) => {
				this.clients = response.data;
				this.user.client.map((a) => {
					this.clients.map((b) => {
						if (a == b._id) { this.clientsNames.push(b); }
					});
				});
			});
	}
	
	addClient() {
		let isAssigned = false;
		this.user.client.map((x) => {
			if (x == this.selectedClient._id) {
				isAssigned = true;
			}
		});
		if (!isAssigned) {
			this.user.client.push(this.selectedClient._id);
			this.clientsNames.push(this.selectedClient);
		}
	}
	
	removeClient(item:any) {
		this.user.client = this.user.client.filter((x) => { return x !== item._id });
		this.clientsNames = this.clientsNames.filter((x) => { return x.name !== item.name });
	}

	setUser(user: User) {
		localStorage.setItem('userInfo', JSON.stringify(user));
	}

	delete() {
		document.querySelector("#confirmation").classList.remove('md-show');
	}

	confirmDelete(id) {
		this.userToDelete = id;
		document.querySelector("#confirmation").classList.add('md-show');
	}

	// SE EJECUTA AL CARGAR EL COMPONENTE
	ngOnInit() {
		if (this.path == 'sales') {
			this.getByClientAndRole();
		} else {
			this.getAll();
			this.getClients();
		}
	}

	openMyModal(event, userId = null) {
		document.querySelector("#"+event).classList.add('md-show');
		this.event = event;

		if (userId !== null) {
			this.getUser(userId);
			this.userId = userId;
			this.isRequired = false;
		} else {
			this.isRequired = true;
		}
	}

	closeMyModal(event) {
		((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
	}

}



// WEBPACK FOOTER //
// ./src/app/components/users/users.component.ts